import { defineStore } from 'pinia'
import type { Account } from '@base/types/account'

export const useAuthStore = defineStore('auth', {
  state: () => ({
    accessToken: null as string | null,
    tokenExpiry: null as number | null,
    account: {} as Account | null
  }),
  getters: {
    abberviatedUsername(state) {
      return state.account?.name
        ? state.account?.name
            .split(' ')
            .map((name: string) => name[0])
            .join('')
        : ''
    }
  },
  actions: {
    setToken(value: string | null, expiry: number | null) {
      this.accessToken = value
      this.tokenExpiry = expiry
    },
    setAccount(value: Account) {
      this.account = value
    }
  }
})
